// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13Xhn","badges":"styles_badges__3VKUH"};